import React, {useContext} from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import OrganizationContext from "../../context/OrganizationContext"
import DataContext from "../../context/DataContext"
import {getOrganizationDataFromStrapi} from "../../utility/strapi/helpers"

type props={
    className?:string
}
function BannerForPartners({className}:props) {
	const {organizationSlug} = useContext(OrganizationContext)
	const {pageProps} = useContext(DataContext)
	const organizations = pageProps?.strapiContent?.data?.organizations
	const organizationData = getOrganizationDataFromStrapi(organizations, organizationSlug)

	const getter = key => {
		return organizationData?.banner?.[key]
	}

	const {t} = useTranslation("common")
	const logo = getter("logo")
	return (<>
		{logo &&
			<div className={`employees_banner relative  alert d-flex flex-column flex-sm-row align-items-center justify-content-between col-11  col-md-12 gap-2 ${className}`}
				style={{backgroundColor: getter("bgColor"), color: getter("textColor"), borderRadius: 16}}
				role="alert">
				<div className="d-flex flex-md-row flex-column  justify-content-start gap-3 gap-md-4 align-items-start">
					<img src={getter("logo")}
						width={"auto"}
						height={21}/>
					<Typography variant="heading20To28" >{t(getter("header")).replace("instance", organizationData?.companyName)}</Typography></div><div><Typography variant="bodySmBold" >{t(getter("subHeader")).replace("instance", organizationData?.companyName)}</Typography>
					<div className="banner_bottom_arrow"/></div>
				<style jsx>{`
				.employees_banner{
					position: relative;
				}

				.banner_bottom_arrow {
					clip-path: polygon(100% 0, 0 0, 50% 51%);
					position: absolute;
					bottom: 0;
					transform:translateY(100%);
					left: 2rem;
					background-color: ${organizationData?.banner?.bgColor};
					width: 35px; 
					height: 30px;
				  }

				  @media and screen (max-width:780px){
					.banner_bottom_arrow {
						width: 35px; 
						height: 30px;
					  }
						.banner_bottom_arrow {
					
					left: 50%;
					transform:translate(-50%,100%);
					
				  }
				  }
				`}</style>
			</div>}</>
	)
}

export default BannerForPartners
